<template>
  <v-menu v-model="menu" open-on-hover>
    <template v-slot:activator="{ on, attrs }">
      <v-btn icon v-bind="attrs" v-on="on">
        <v-icon>mdi-list-box-outline</v-icon>
      </v-btn>
    </template>
    <v-list max-width="300px" dense>
      <v-list-item
        v-for="(item, index) in items"
        :key="index"
        @click="$emit('onSelect', item.text)"
      >
        <v-list-item-title>
          <b>{{ item._id }}</b> {{ item.title }}
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  data() {
    return {
      menu: false,
    };
  },
  computed: {
    items() {
      return this.$store.getters.smsTemplates;
    },
  },
};
</script>

<style>
</style>